import React from 'react'

export const bannerList = [
  {
    id: 0,
    title: "banner1",
    path: "/banner2",
    image:"https://live.staticflickr.com/65535/50343188162_002d088e9b_z.jpg"
  },
  {
    id: 1,
    title: "banner2",
    path: "/banner2",
    image: "https://live.staticflickr.com/65535/50343188417_00c2cf8788_z.jpg"
   
  },
  {
    id: 2,
    title: "banner3",
    path: "/banner3",
    image:"https://live.staticflickr.com/65535/50343028526_87549dbcf3_z.jpg"
 
  },
  {
    id: 3,
    title: "banner4",
    path: "/banner4",
    image: "https://live.staticflickr.com/65535/50343030806_b312fd25a1_z.jpg"

  },

  
  {
    id: 4,
    title: "banner5",
    path: "/banner5",
    image:"https://live.staticflickr.com/65535/50343188247_3f6a42cb73_z.jpg"

  }
];


export const droneList = [
    {
      id: 0,
      title: "Drone Teaser",
      path: "/Drone Teaser",
      video:"https://player.vimeo.com/video/457524506?title=0&byline=0&portrait=0"

    }
  ];

  export const defaultList = [
    {
      id: 0,
      title: "Bulunamadı",

    }
  ];


  export const picList = [
  
    {
      id: 0,
      title: "Düğün Çekimi",
      path: "/Düğün Çekimi",
      image:"//live.staticflickr.com/65535/50343195882_44c8fea6fb_k.jpg"
     
    },
    {
      id: 1,
      title: "Konser-Etkinlik",
      path: "/Konser-Etkinlik",
      image:"https://live.staticflickr.com/65535/50343195687_28185c5b8f_z.jpg"
   
    }
    
 
  ];


  export const videoContentList = [
   {
      id: 0,
      title: "UNFPA - kırsala Destek ",
      path: "/UNFPA - kırsala Destek ",
      video:"https://player.vimeo.com/video/589299298?title=0&byline=0&portrait=0"
    },
    
    {
      id: 1,
      title: "Karadeniz + Batum ",
      path: "/Karadeniz + Batum ",
      video:"https://player.vimeo.com/video/371158064?title=0&byline=0&portrait=0"
   
    },
    
    {
      id: 2,
      title: "Bitkisel Yağ Sanayicileri Derneği - Tanıtım Filmi ",
      path: "/Bitkisel Yağ Sanayicileri Derneği - Tanıtım Filmi ",
      video:"https://player.vimeo.com/video/589303633?title=0&byline=0&portrait=0"
   
    },
    
    {
      id: 3,
      title: "Big Dutchman - Sosyal Medya Filmi ",
      path: "/Big Dutchman - Sosyal Medya Filmi ",
      video:"https://player.vimeo.com/video/589306536?title=0&byline=0&portrait=0"
   
    },
    
    {
      id: 4,
      title: "Coffee Break ",
      path: "/Coffee Break ",
      video: "https://player.vimeo.com/video/375278140?title=0&byline=0&portrait=0"
     
    },
   
    {
      id: 5,
      title: "ANKA Off Road Tanıtım Filmi",
      path: "/ANKA Off Road Tanıtım Filmi",
      video:"https://player.vimeo.com/video/369186855?title=0&byline=0&portrait=0"
   
    },
    
    {
      id: 6,
      title: "NEF Beauty - Sosyal Medya Filmi ",
      path: "/NEF Saç Tasarım ve Güzellik Merkezi ",
      video: "https://player.vimeo.com/video/454739888?title=0&byline=0&portrait=0"
 
    },

    
    {
      id: 7,
      title: "Barış Pınarı Harekatı ",
      path: "Barış Pınarı Harekatı ",
      video:"https://player.vimeo.com/video/369185498?title=0&byline=0&portrait=0"
 
    },
      
    {
      id: 8,
      title: "İstanbul - Short Story",
      path: "/İstanbul - Short Story",
      video:"https://player.vimeo.com/video/387919326?title=0&byline=0&portrait=0"
 
    },
      
    {
      id: 9,
      title: "15 Temmuz Anısına",
      path: "/15 Temmuz Anısına",
      video:"https://player.vimeo.com/video/369190695?title=0&byline=0&portrait=0"
 
    },
      
    {
      id: 10,
      title: "Summer Bride",
      path: "/Summer Bride",
      video:"https://player.vimeo.com/video/367866887?title=0&byline=0&portrait=0"
 
    },
    
    {
      id: 11,
      title: "Big Dutchman",
      path: "/Big Dutchman",
      video:"https://player.vimeo.com/video/598307074?title=0&byline=0&portrait=0"
 
    },
    ];


  export const videoAdList = [
    {
      id: 0,
      title: "Unicef Eğitim Programı - Geri Dönüşüm",
      path: "/Unicef Eğitim Programı - Geri Dönüşüm",
      video:"https://player.vimeo.com/video/496421591?title=0&byline=0&portrait=0"

    },
    {
      id: 1,
      title: "Türkiye İş Kurumu - Açık İş İlanı",
      path: "/Türkiye İş Kurumu - Açık İş İlanı",
      video: "https://player.vimeo.com/video/422947968?title=0&byline=0&portrait=0"
    },
    {
      id: 2,
      title: "Gotogemba Profesyonel İş ve Eğitim Platformu",
      path: "/Gotogemba Profesyonel İş ve Eğitim Platformu",
      video:"https://player.vimeo.com/video/496415998?title=0&byline=0&portrait=0"
   
    },
    {
      id: 3,
      title: "Enformasyonline.com - Uygulama Tanıtım",
      path: "/Enformasyonline.com - Uygulama Tanıtım",
      video:"https://player.vimeo.com/video/390574981?title=0&byline=0&portrait=0"
 
    },
    {
      id: 4,
      title: "Goldexco.in Video Reklam",
      path: "/Goldexco.in Video Reklam",
      video:"https://player.vimeo.com/video/478547562?title=0&byline=0&portrait=0"
 
    },
    {
      id: 5,
      title: "Tsunami Yayınları Video Reklam",
      path: "/Tsunami Yayınları Video Reklam",
      video:"https://player.vimeo.com/video/475494002?title=0&byline=0&portrait=0"
 
    },
    {
      id: 6,
      title: "Forev Yapı - Eyüp",
      path: "/Forev Yapı - Eyüp",
      video:"https://player.vimeo.com/video/368119635?title=0&byline=0&portrait=0"
 
    },
     {
      id: 7,
      title: "Bu Ev Mobilya Video Reklam",
      path: "/Bu Ev Mobilya Video Reklam",
      video:"https://player.vimeo.com/video/368133973?title=0&byline=0&portrait=0"
 
    },
   {
      id: 8,
      title: "Veysel Tiryaki Seçim Kampanyası",
      path: "/Veysel Tiryaki Seçim Kampanyası",
      video:"https://player.vimeo.com/video/367871468?title=0&byline=0&portrait=0"
    },
    {
      id: 9,
      title: "Ata Alkan Seçim Kampanyası",
      path: "/Ata Alkan Seçim Kampanyası",
      video:"https://player.vimeo.com/video/496437773?title=0&byline=0&portrait=0"
    },
    {
      id: 10,
      title: "Unicef Eğitim Programı - Gölgesinden Çiz",
      path: "/Unicef Eğitim Programı - Gölgesinden Çiz",
      video:"https://player.vimeo.com/video/496420524?title=0&byline=0&portrait=0"
    },
    {
      id: 11,
      title: "Türkiye İş Kurumu - İstihdam Seferberliği",
      path: "/Türkiye İş Kurumu - İstihdam Seferberliği",
      video:"https://player.vimeo.com/video/422947292?title=0&byline=0&portrait=0"
    },
    {
      id: 12,
      title: "Goldexco.in - İninal Kart",
      path: "/Goldexco.in - İninal Kart",
      video:"https://player.vimeo.com/video/478197905?title=0&byline=0&portrait=0"
    },
    {
      id: 13,
      title: "Enformasyonline.com Video Reklam",
      path: "/Enformasyonline.com Video Reklam",
      video:"https://player.vimeo.com/video/389564750?title=0&byline=0&portrait=0"
    },
    {
      id: 14,
      title: "Unicef - Dünya Çocuk Günü",
      path: "/Unicef - Dünya Çocuk Günü",
      video:"https://player.vimeo.com/video/374770649?title=0&byline=0&portrait=0"
    },
    {
      id: 15,
      title: "Türkiye İş Kurumu - Meslek Danışmanlığı",
      path: "/Türkiye İş Kurumu - Meslek Danışmanlığı",
      video:"https://player.vimeo.com/video/422946249?title=0&byline=0&portrait=0"
    },
   {
      id: 16,
      title: "Reform Koltuk Video Reklam",
      path: "/Reform Koltuk Video Reklam",
      video:"https://player.vimeo.com/video/496450575?title=0&byline=0&portrait=0"
    }, 
   {
      id: 17,
      title: "Kocaeli Gazetesi Video Reklam",
      path: "/Kocaeli Gazetesi Video Reklam",
      video:"https://player.vimeo.com/video/496451543?title=0&byline=0&portrait=0"
    }, 
   {
      id: 18,
      title: "18 Mart Çanakkale",
      path: "/18 Mart Çanakkale",
      video:"https://player.vimeo.com/video/374993909?title=0&byline=0&portrait=0"
    }, 
   {
      id: 19,
      title: "Türkiye İş Kurumu - Meslek Eğitim Kursları",
      path: "/Türkiye İş Kurumu - Meslek Eğitim Kursları",
      video:"https://player.vimeo.com/video/422949193?title=0&byline=0&portrait=0"
    }, 
  ];
